import { gql } from '@apollo/client';

export const SAVE_FORM_ANSWER_MUTATION = gql`
  mutation createPatientFormAnswer($formId: Int!, $formElementId: Int!, $data: String!) {
    createPatientFormAnswer(formId: $formId, formElementId: $formElementId, data: $data) {
      answer {
        id
        data
        formElementId
      }
    }
  }
`;

export interface SaveFormAnswerMutationArguments {
  formId: number;
  formElementId: number;
  data: string;
}

export interface SaveFormAnswerMutationResponse {
  createPatientFormAnswer: {
    answer: {
      id: string;
      data: string;
      formElementId: number;
      percentageComplete: number;
    };
  };
}
